import { useCallback, useEffect, useState } from "react";
import getKemChatPayload from "../utils/getKemChatPayload";
import type { TKemDefaultPayloadResponseData } from "../utils/types";

interface UseKemDefaultPayloadOptions {
  autoFetch?: boolean;
}

const useKemDefaultPayload = (options: UseKemDefaultPayloadOptions = {}) => {
  const { autoFetch = true } = options;
  const [defaultChatPayload, setDefaultChatPayload] = useState<
    TKemDefaultPayloadResponseData | undefined
  >(undefined);
  const [hasLoadedDefaultPayload, setHasLoadedDefaultPayload] = useState(false);

  const loadDefaultChatPayload = useCallback(async () => {
    const payload = await getKemChatPayload();
    setDefaultChatPayload(payload);
    setHasLoadedDefaultPayload(true);
    return payload;
  }, []);

  useEffect(() => {
    if (!autoFetch) return;
    void loadDefaultChatPayload();
  }, [autoFetch, loadDefaultChatPayload]);

  return {
    defaultChatPayload,
    hasLoadedDefaultPayload,
    loadDefaultChatPayload,
  };
};

export default useKemDefaultPayload;
